<template>
	<transition
		enter-active-class="show"
		leave-active-class="hide"
	>
		<div
			v-if="expired"
			class="aceitar__termos show"
			ref="refElement"
		>
			<slot>
				Ao navegar em nosso site você concorda com a nossa <a :href="politica"> Política de Privacidade </a> e nossos <a :href="termos"> Termos de uso </a>
			</slot>

			<div class="text-center mt-2">
				<button class="btn-primary btn" @click.prevent="aceitar" type="button">Li e Concordo</button>
			</div>
		</div>
	</transition>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
	termos: {
		type: String,
		required: true,
	},
	politica: {
		type: String,
		required: true,
	},
})

const hoje = new Date().getTime()
const host = location.host

const loadCookies = () => {
	let coockies = localStorage.getItem(host)

	if (coockies === null || coockies === undefined) return true

	coockies = JSON.parse(coockies)

	if (coockies.expiraEm < hoje) return true

	return false
}

const diasEmMilisegundos = dias => dias * 60 * 60 * 60 * 1000

const expired    = ref( loadCookies() )
const refElement = ref( undefined )
const aceitar    = () => {
	const expiraEm = hoje + diasEmMilisegundos(24)

	localStorage.setItem(host, JSON.stringify({
		expiraEm,
	}))

	expired.value = false
}
</script>
